import { mapGetters } from "vuex";
import { showErrorSnackBar, showSuccessSnackBar, showInfoSnackBar } from "@/utils/SnackBartHelper"
import diff from "deep-diff";
import DiagnosticProposalService from '@/services/firebase/DiagnosticProposal/DiagnosticProposalService';
import cloneDeep from 'lodash/cloneDeep';
import { openDatabase } from '@/pages/Projects/Utils/IndexedDB.js';
import LeadsService from "@/services/server/LeadsService.js";
import Rules from "@/utils/Rules";

import UtilsProjects from "@/pages/Projects/Utils/Utils.js";

import DiagnosticStorage from '@/services/storage/DiagnosticStorage';
import DiagnosticService from "@/services/server/DiagnosticService.js";
import DiagnosticServiceFirebase from "@/services/firebase/Diagnostic/DiagnosticService";

import NextStepProject from "@/components/Projects/NextStepProject.vue"
import DiagnosticStepper from "@/components/Projects/Diagnostic/DiagnosticStepper.vue"

import CheckListTab from "@/components/Projects/Diagnostic/Tabs/CheckList/CheckList.vue"
import HistoricTab from "@/components/Projects/Diagnostic/Tabs/Historic/Historic.vue"
import ProposalTab from "@/components/Projects/Diagnostic/Tabs/Proposal/Proposal.vue"
import NotificationsService from "@/services/server/NotificationsService";
import ProjectsService from "@/services/server/ProjectsService";
import HistoricService from "@/services/firebase/Historic/HistoricService";
import AverageNextStep from "@/components/AverageNextStep/AverageNextStep.vue"

export default {
    name: "Diagnóstico",

    components: {
        NextStepProject,
        DiagnosticStepper,
        CheckListTab,
        HistoricTab,
        ProposalTab,
        AverageNextStep
    },
    props: {
        openModal: {
            type: Boolean,
            default: false
        },
        idLead: {
            type: String,
            default: null
        },
        idProject: {
            type: String,
            default: null
        },
        idDiagnostic: {
            type: String,
            default: null
        },
        closeFunc: {
            type: Function,
            default: () => { }
        },
        currentStep: {
            type: String,
            default: null,
        }
    },
    data: () => ({
        model: null,
        revisionDialog: false,
        desiredProposal: [],
        filterRequiredFields: [],
        buttonMessage: "Solicitar Propostas",
        db: null,
        isValidForm: false,
        loadingDialog: true,
        savedImages: [],
        is_loading: false,
        loading: false,
        loadingMessage: "Carregando dados do diagnóstico...",
        is_created: false,
        dialogAlert: false,
        dialog: false,
        dialogConfirmDeleteLocal: false,
        id_project: null,
        id_diagnostic: null,
        proposalsList: [],
        is_completed: true,
        oldDiagnostic: {},
        // Propriedades para o modal de carregamento da estrutura de dados
        isUpdatingDataStructure: false,
        updatingDataStructureMessage: "A estrutura de dados está sendo atualizada...",
        diagnostic: {
            revision: {},
            historics: [],
            solutionList: [],
            requestedReviewDate: null,
        },
        steps: [
            {
                id: 'checklist',
                name: 'CheckList',
                step: '1',
                editable: true,
                complete: false,
                rules: [() => true],
            },
            {
                id: 'historic',
                name: 'Histórico',
                step: '2',
                editable: true,
                complete: false,
                rules: [() => true],
            },
            {
                id: 'proposal',
                name: 'Proposta',
                step: '3',
                editable: true,
                complete: false,
                rules: [() => true],
            },
        ],
        visibleTabs: {
            checklist: true,
            historic: false,
            proposal: false,
        },
        localStorageData: null,
        existDiagnosticIndexedDB: false,
        disabledButtonNextStep: false,
        readonlyScreen: true,
        requestSaveProposal: false,
        lastProposalRevisionStatus: null,
        lastProposal: null,
        enableAddEvent: false,
        project_data: null,
        loadingSaveRevision: false,
        showAverageNextStep: false,
        nextStepVariable: "waterscan",
    }),

    computed: {
        ...mapGetters([
            "getFranqueados",
            "getCurrentUser",
            "getCurrentUserRank",
            "getStatusCanDeletedDataAdmin",
        ]),
        isOline() {
            return navigator.onLine
        },
        isFranchisee() {
            return this.getCurrentUserRank === "Franqueado"
        },
        disableSaveButton() {
            return (this.isFranchisee && this.diagnostic.requestedReviewDate !== null);
        },
        rulesRequired() {
            return Rules.required()
        },
    },
    
    methods: {
        async saveRevision() {
            try {
                this.loadingSaveRevision = true
                await DiagnosticService.update({
                    id_doc: this.diagnostic.id_doc,
                    revision: this.diagnostic.revision,
                })
                switch (this.diagnostic.revision.status) {
                    case 'approved':
                        await this.addStatusProject(this.idProject, 304, 302)
                        break;
                    case 'revision':
                        await this.addStatusProject(this.idProject, 208, 202)
                        break;
                    case 'reproved':
                        await this.addStatusProject(this.idProject, 207, 201)
                        break;
                    default:
                        break;
                }
            } catch (error) {
                showErrorSnackBar("Erro ao Salvar Revisão")
                console.error(error)
            } finally {
                showSuccessSnackBar("Revisão Salva!")
                this.loadingSaveRevision = false
                this.revisionDialog = false
                this.close()
            }
        },
        async addStatusProject(id_project, status, statusAdm = null) {
            await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.DIAGNOSTIC, status, this.currentStep)
            await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.DIAGNOSTIC, statusAdm ? statusAdm : status, this.currentStep, false)
        },
        checkFields() {
            if (this.$refs.diagnosticForm && !this.$refs.diagnosticForm.validate()) throw new Error("Preencha todos os campos!")
            if (!this.diagnostic.solutionList?.length && this.filterRequiredFields.includes('checklist')) {
                throw new Error("Adicione ao menos uma solução!")
            }
            if (!this.diagnostic.hydrometerList?.length && this.filterRequiredFields.includes('hydrometer')) throw new Error("Adicione ao menos um hidrometro!")
            if (!this.diagnostic.reservoirList?.length && this.filterRequiredFields.includes('reservoir')) throw new Error("Adicione ao menos um reservatorio!")
            if (!this.diagnostic.bombList?.length && this.filterRequiredFields.includes('bomb')) throw new Error("Adicione ao menos uma bomba!")
            if (!this.diagnostic.historics?.length && this.filterRequiredFields.includes('historic')) throw new Error("Adicione ao menos 1 mes ao histórico!")
        },
        async save() {
            this.is_loading = true

            if (!this.isOline) {
                showInfoSnackBar("Você está offline no momento, as informações foram salvas localmente")
                this.close()
                return
            }

            try {
                await this.saveOrCreate()
                await this.deleteItemIndexedDB(this.idProject)
                this.is_loading = false
                this.close()
            } catch (error) {
                showErrorSnackBar("Você está offline no momento, as informações foram salvas localmente")
            }
        },
        async saveProposal(proposal) {
            this.is_loading = true
            await DiagnosticProposalService.createDiagnostic(proposal)
            await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.DIAGNOSTIC, "Criado", this.currentStep)
            await this.addStatusProject(this.idProject, 205, 211) //obs: dont following the pattern stablished with franchisee status first
            this.is_loading = false
            this.close()
        },
        async processImage(id_doc, data, fileProp, pathProp) {
            try {
                if (data.hasOwnProperty(fileProp)) {
                    if (data[pathProp]) await DiagnosticStorage.deleteImg(data[pathProp])
                    data[pathProp] = null
                    if (data[fileProp]) {
                        data[pathProp] = await DiagnosticStorage.uploadImg(id_doc, data[fileProp])
                        this.savedImages.unshift({ name: `Imagem ${this.savedImages.length + 1}` })
                    }
                }
                delete data[fileProp]
            } catch (error) {
                console.error(`Error processing image for ${fileProp}:`, error);
            }
        },
        async saveImages(diagnosticId, checklist) {
            const processImage = this.processImage
            async function processChecklistItems(items, fileProp, pathProp) {
                for (const key in items) {
                    await processImage(diagnosticId, items[key], fileProp, pathProp);
                }
            }

            const checklistMappings = [
                { items: checklist.solutionList, fileProp: 'file_after_solution', pathProp: 'path_after_solution' },
                { items: checklist.solutionList, fileProp: 'file_before_solution', pathProp: 'path_before_solution' },
                { items: checklist.reservoirList, fileProp: 'file_photo', pathProp: 'path_photo' },
                { items: checklist.reservoirList, fileProp: 'file_photo2', pathProp: 'path_photo2' },
                { items: checklist.hydrometerList, fileProp: 'file_photo', pathProp: 'path_photo' },
                { items: checklist.hydrometerList, fileProp: 'file_photo2', pathProp: 'path_photo2' },
                { items: checklist.bombList, fileProp: 'file_photo', pathProp: 'path_photo' },
                { items: checklist.bombList, fileProp: 'file_photo2', pathProp: 'path_photo2' }
            ];

            for (const { items, fileProp, pathProp } of checklistMappings) {
                await processChecklistItems(items, fileProp, pathProp);
            }
        },
        async saveDiagnostic(mode = "edit") {
            try{
                const deleteImages = this.$refs.CheckListTab.deletedItemsWithPhoto
                async function updateProposalsStatus(proposalsList) {
                    const updateProposal = async (proposal) => {
                        const updatedProposal = {
                            ...proposal,
                            revision: { ...proposal.revision, status: "outdated" }
                        };
                        await DiagnosticProposalService.editWaterScanProposal(updatedProposal.id_doc, updatedProposal);
                    };
                    await Promise.all(proposalsList.map(updateProposal));
                }

                async function updateSolutions(solutionsList,id_diagnostic) { 
                    if (solutionsList && solutionsList.length > 0) {
                        for (const solution of solutionsList) {
                            if(solution.isDeleted === true){
                                await DiagnosticServiceFirebase.deleteDiagnosticSolution(id_diagnostic, solution.id)
                            }else{
                                await DiagnosticServiceFirebase.createDiagnosticSolution(solution, id_diagnostic);
                            }
                        }
                    }
                }

                const transaction = this.db.transaction(["diagnostics"], "readwrite");
                const diagnosticsIndexed = transaction.objectStore("diagnostics");
                const response = diagnosticsIndexed.get(this.idProject)
                this.requestSaveProposal = false
    
                await new Promise((resolve, reject) => {
                    response.onsuccess = async () => {
                        let currentData = response.result;
    
                        if (!currentData) {
                            this.is_loading = false
                            return resolve()
                        }
    
                        await HistoricService.saveHistoricList(currentData.historics)
                        if (currentData?.historicsToDelete?.length) await HistoricService.deleteHistoricList(currentData.historicsToDelete);
    
                        delete currentData.historicsToDelete
                        delete currentData.historics
                        if (mode === "edit") {
                            //EDIT
                            const hasDiff = diff(currentData, this.oldDiagnostic);
                            if (hasDiff) {
                                await updateProposalsStatus(this.proposalsList)
                            }
                            for (const path of deleteImages) {
                                await DiagnosticStorage.deleteImg(path)
                            }
                            await this.saveImages(this.diagnostic.id_doc, currentData)
                            const { solutionList, ...dataWithoutSolutions } = currentData;
                            await DiagnosticService.update({...dataWithoutSolutions,id_doc: this.diagnostic.id_doc, lastUpdateAt: new Date().getTime()});
                            const filteredSolutionList = solutionList.filter(solution => solution.isModified || solution.isDeleted)
                            await updateSolutions(filteredSolutionList, this.diagnostic.id_doc)

                            await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.DIAGNOSTIC, "Rascunho Salvo", this.currentStep)
                            //currentData.lastLogMessageADM !== 204
                            if(this.isFranchisee) {
                                await this.addStatusProject(this.idProject, 205, 211); //obs: dont following the pattern stablished with franchisee status first
                            }
    
                            showSuccessSnackBar("Rascunho salvo com sucesso")
                            resolve()
                        } else {
                            //CREATE
                            // TODO: verificar se o diagnostic já existe antes de criar um novo para não substituir o existente
                            const diagnosticResponse = await DiagnosticServiceFirebase.getDiagnosticByProjectId(this.idProject)
                            if(diagnosticResponse.length > 0){
                                this.diagnostic.id_doc = diagnosticResponse[0].id_doc
                                await this.saveDiagnostic("edit")
                                resolve()
                                return;
                            }
                            // TODO: Corrigir o primeiro create pois está criando com estrutura antiga e não está salvando as soluções em sub coleção
                            
                            const { solutionList, ...dataWithoutSolutions } = currentData;
                            const idReceived = await DiagnosticService.create(dataWithoutSolutions)


                            this.id_diagnostic = idReceived.data.data;
                            await this.saveImages(this.id_diagnostic, currentData)
                            const diagnosticReceived = { id_doc: this.id_diagnostic, ...dataWithoutSolutions }
                            await updateSolutions(solutionList, this.id_diagnostic)

                            delete diagnosticReceived.historics;
                            delete diagnosticReceived.historicsToDelete;
                            await DiagnosticService.update(diagnosticReceived)
                            
                            this.diagnostic = cloneDeep({...diagnosticReceived,solutionList: solutionList || []})
                            this.oldDiagnostic = cloneDeep({...diagnosticReceived,solutionList: solutionList || []})
                            await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.DIAGNOSTIC, "Criado", this.currentStep)
                            await this.addStatusProject(this.idProject, 205, 211) //obs: dont following the pattern stablished with franchisee status first
                            showSuccessSnackBar("Rascunho Criado!")
                            resolve()
                        }
                    }
                })
            }catch (error) {
                console.error(error);
                showErrorSnackBar(error.message);
                this.is_loading = false;
                return
            }
        },
        async saveOrCreate() {
            try {
                if (this.diagnostic.id_doc) await this.saveDiagnostic()
                else await this.saveDiagnostic("create")
            } catch (error) {
                console.error(error)
                await UtilsProjects.createErrorLog(this.idProject, UtilsProjects.STEPS.DIAGNOSTIC, "Erro ao Salvar", this.currentStep)
                showErrorSnackBar('Erro ao Salvar')
                this.close()
                throw new Error('Erro ao Salvar')
            }

        },
        async nextStep() {
            this.is_loading = true
            if (this.isOline) {
                try {
                    await this.saveOrCreate()
                } catch (error) {
                    console.error(error)
                    this.close()
                    return
                }
                this.is_loading = true
                if (this.buttonMessage == "Adicionar Proposta" || this.buttonMessage == "Adicionar Nova Proposta") {
                    try {
                        await this.$refs.ProposalTab.saveProposal()
                    } catch (error) {
                        showErrorSnackBar(error.message);
                        this.is_loading = false;
                        return
                    }

                    let messageList = [];
                    let data = {};
                    const lastProposal = await DiagnosticProposalService.getLastProposalByDiagnosticId(this.idDiagnostic)
                    this.lastProposal = lastProposal[0]

                    const mapProposalsTypes = {
                        model_performance: "Performance",
                        investment: "Investimento",
                        pre_fixed: "Pré-Fixado",
                        management: "Gestão",
                    }
                    const status = this.$refs.ProposalTab.revision.status
                    const _currentStep = this.currentStep === UtilsProjects.STEPS.APPROVAL ? UtilsProjects.STEPS.DIAGNOSTIC : this.currentStep
                    async function checkStatus(project_data, idProject, lastProposal) {
                        switch (status) {
                            case "approved":
                                await UtilsProjects.createSuccessLog(idProject, UtilsProjects.STEPS.DIAGNOSTIC, "Aprovada", _currentStep)
                                data = UtilsProjects.buildFranchiseeNotificationData(project_data,
                                    `Estamos felizes em informar que foi adicionado uma proposta do tipo *${mapProposalsTypes[lastProposal.typeProposal.type]}* com status de *aprovada* no seu projeto!`)
                                break;
                            case "revision":
                                await UtilsProjects.createWarningLog(idProject, UtilsProjects.STEPS.DIAGNOSTIC, "Revisão", _currentStep)
                                // data = UtilsProjects.buildFranchiseeNotificationData(project_data,
                                //     `Foi adicionado uma proposta do tipo *${mapProposalsTypes[lastProposal.typeProposal.type]}* com o status de *Revisão*, verifique o seu *WATERSCAM* para mais informações!`)
                                break;
                            case "reproved":
                                await UtilsProjects.createWarningLog(idProject, UtilsProjects.STEPS.DIAGNOSTIC, "Reprovada", _currentStep)
                                data = UtilsProjects.buildFranchiseeNotificationData(project_data,
                                    `Infelizmente uma proposta do tipo *${mapProposalsTypes[lastProposal.typeProposal.type]}*, teve seu status atualizado para *reprovado*! Verifique o *WATERSCAM* para mais informações!`);
                                break;
                            case "outdated":
                                await UtilsProjects.createWarningLog(idProject, UtilsProjects.STEPS.DIAGNOSTIC, "Desatualizada", _currentStep)
                                data = UtilsProjects.buildFranchiseeNotificationData(project_data,
                                    `Como houveram alterações no seu *WATERSCAM*, todas as suas propostas agora possuem o status de _Desatualizado_`)
                                break;
                            default:
                                return "Nao identificado"
                        }
                    }

                    try {
                        await checkStatus(this.project_data, this.idProject, this.lastProposal)
                        messageList.push(data)
                        if (this.project_data.configs?.wpp_notification ?? true) {
                            await NotificationsService.bootProjectNotification(messageList)
                        }
                        await UtilsProjects.updateProjectSteps(this.idProject, 'approval', true, false)
                        await this.addStatusProject(this.idProject,303,301)
                        
                        await this.deleteItemIndexedDB(this.idProject)
                    } catch (e) {
                        await UtilsProjects.createWarningLog(this.idProject, UtilsProjects.STEPS.DIAGNOSTIC, `Notificação não enviada`, 'Notificações');
                        console.error(e)
                    } finally {
                        showSuccessSnackBar("Propostas adicionada com sucesso!")
                    }
                    this.is_loading = false
                    this.close()
                } else {
                    const transaction = this.db.transaction(["diagnostics"], "readwrite");
                    const diagnosticsIndexed = transaction.objectStore("diagnostics");
                    const response = diagnosticsIndexed.get(this.idProject)
                    this.requestSaveProposal = false
                    response.onsuccess = async () => {
                        const currentData = response.result;
                        let dataToUpdate = {
                            id_doc: this.idDiagnostic || currentData.id_doc,
                            requestedReviewDate: new Date(),
                            revision: {
                                status: null
                            }
                        };

                        try {
                            this.checkFields();
                            if (currentData) {
                                // Primeiro salvamos as imagens
                                const deleteImages = this.$refs.CheckListTab.deletedItemsWithPhoto;
                                for (const path of deleteImages) {
                                    await DiagnosticStorage.deleteImg(path);
                                }
                                await this.saveImages(this.diagnostic.id_doc, currentData);
                                
                                // Depois atualizamos os dados
                                dataToUpdate = { ...currentData, ...dataToUpdate };
                                this.diagnostic = cloneDeep(dataToUpdate);
                            } else {
                                console.warn("Nenhuma alteração foi feita, atualizando apenas a data de revisão solicitada.");
                            }
                            const { solutionList, ...dataWithoutSolutions } = dataToUpdate;
                            await DiagnosticService.update(dataWithoutSolutions);

                            await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.DIAGNOSTIC, "Proposta Solicitada", this.currentStep);

                            await this.addStatusProject(this.idProject, 210, 204)

                            showSuccessSnackBar("Propostas solicitadas com sucesso!");
                            await this.deleteItemIndexedDB(this.idProject)
                            this.is_loading = false
                            await this.waitForAverageNextStep()
                            this.close()
                        } catch (error) {
                            showErrorSnackBar(error.message);
                            this.is_loading = false;
                            return
                        }
                    }
                }
            } else {
                showInfoSnackBar("Você está offline no momento, as informações foram salvas localmente")
            }
        },




        close() {
            this.closeFunc('diagnostic')
        },
        async waitForAverageNextStep() {
            return new Promise(resolve => {
              this.showAverageNextStep = true;
          
              const modal = this.$refs.averageModal;
          
              const handler = () => {
                modal.$off('closed', handler);
                resolve();
              };
          
              modal.$on('closed', handler);
            });
          },
        nextTab(tabStep) {
            if (!this.isFranchisee) {

                if (tabStep == 3) {
                    this.disabledButtonNextStep = false
                } else {
                    this.disabledButtonNextStep = true
                }
            }
            const index = this.steps.findIndex(({ step }) => step === tabStep)

            if (index < 0) throw new Error(`Não foi encontrado a aba: ${tabStep}`)
            Object.keys(this.visibleTabs).forEach(
                (key) => {
                    if (key === this.steps[index].id) {
                        this.visibleTabs[key] = true
                    } else {
                        this.visibleTabs[key] = false
                    }
                }
            )

        },
        updateDiagnostic(diagnostic) {
            this.addEvent(diagnostic)
            this.diagnostic = diagnostic
        },
        validateTab(tabName, status) {
            let index = this.steps.findIndex(
                ({ id }) => {
                    return id === tabName
                }
            )
            if (index < 0) {
                throw new Error(`Não foi encontrado a aba: ${tabName}`)
            }
            this.steps[index].rules = [() => status]
        },
        async getLocalStorageDiagnostic() {
            this.diagnostic = cloneDeep(this.localStorageData)
            await this.changeButtonName()
            this.enableAddEvent = true
            this.dialogAlert = false
        },
        async cancelGetLocalStorageDiagnostic() {
            this.dialogConfirmDeleteLocal = true;
        },
        confirmDeleteLocal() {
            // Chama o método original para realmente excluir
            this.deleteItemIndexedDB(this.idProject);
            this.dialogAlert = false;
            this.dialogConfirmDeleteLocal = false;
            this.changeButtonName();
            this.enableAddEvent = true;
        },
        cancelDeleteLocal() {
            this.dialogConfirmDeleteLocal = false;
        },
        async checkOldHistorics(){
            if (this.oldDiagnostic?.historics?.length) {
                this.oldDiagnostic.historics.forEach((historic) => {
                    historic.id_project = this.idProject
                });

                await HistoricService.saveHistoricList(this.oldDiagnostic.historics)
                await DiagnosticServiceFirebase.removeHistoricListFromDiagnostic(this.idDiagnostic)
            }
        },
        async getFirestoreDiagnostic() {
            if (this.idDiagnostic) {
                const diagnosticResponse = await DiagnosticServiceFirebase.getDiagnosticByDiagnosticId(this.idDiagnostic)
                this.proposalsList = await DiagnosticProposalService.getWaterScanProposalByDiagnosticId(this.idDiagnostic);
                this.oldDiagnostic = cloneDeep(diagnosticResponse)
                if(this.oldDiagnostic.solutionList){
                    // Ativa o modal de carregamento
                    this.isUpdatingDataStructure = true;
                    
                    try {
                        this.oldDiagnostic = await DiagnosticServiceFirebase.legacyDiagnosticSolution(diagnosticResponse)
                    } finally {
                        // Desativa o modal de carregamento
                        this.isUpdatingDataStructure = false;
                    }
                }else{
                    this.oldDiagnostic.solutionList = await DiagnosticServiceFirebase.getDiagnosticSolutionByDiagnosticId(this.idDiagnostic)
                }

                await this.checkOldHistorics()
            } else {
                this.buttonMessage = "Solicitar Propostas"
            }
        },
        async deleteItemIndexedDB(id) {
            const transaction = this.db.transaction(["diagnostics"], "readwrite");
            const diagnosticsIndexed = transaction.objectStore("diagnostics");
            await diagnosticsIndexed.delete(id);
        },
        async checkIndexedDB() {
            this.db = await openDatabase("diagnostics", 1);

            if (!this.db) {
                console.error("Database not initialized.");
                return;
            }
            if (!this.idProject) return;
            const transaction = this.db.transaction(["diagnostics"], "readwrite");
            const diagnosticsIndexed = transaction.objectStore("diagnostics");
            const response = diagnosticsIndexed.get(this.idProject)

            response.onsuccess = async () => {
                const currentData = response.result;
                this.oldDiagnostic.historics = await HistoricService.getAllHistoricsByProjectId(this.idProject);
                this.diagnostic = cloneDeep(this.oldDiagnostic)
                if(!this.diagnostic)this.diagnostic = cloneDeep(this.oldDiagnostic)
                if (!this.diagnostic.revision) this.diagnostic.revision = {}
                if (currentData) {
                    this.localStorageData = currentData
                    if (this.localStorageData.lastUpdateAt <= this.oldDiagnostic.lastUpdateAt) {
                        this.deleteItemIndexedDB(this.idProject)
                        await this.changeButtonName()
                        this.enableAddEvent = true
                        return
                    }

                    // Sempre mostrar o modal se houver dados locais
                    this.dialogAlert = true;

                    this.existDiagnosticIndexedDB = true
                    await this.changeButtonName()
                } else {
                    this.existDiagnosticIndexedDB = false
                    await this.changeButtonName()
                    this.enableAddEvent = true
                }
            }

        },
        async addEvent(data) {
            const transaction = this.db.transaction(["diagnostics"], "readwrite");
            const diagnosticsIndexed = transaction.objectStore("diagnostics");
            await diagnosticsIndexed.put({ ...data, lastUpdateAt: new Date().getTime() });
        },
        async changeButtonName() {
            if (this.diagnostic.requestedReviewDate) {
                const revision = this.diagnostic.revision
                switch (revision.status) {
                    case 'approved':
                        if (this.isFranchisee) {
                            this.readonlyScreen = true
                            this.disabledButtonNextStep = true
                            this.buttonMessage = `Waterscan Aprovado`
                        } else {
                            this.readonlyScreen = false
                            this.disabledButtonNextStep = true
                            this.buttonMessage = `Adicionar Proposta`
                        }
                        break;
                    case 'revision':
                        this.readonlyScreen = false
                        this.disabledButtonNextStep = false
                        if (this.isFranchisee) this.buttonMessage = "Enviar Revisão"
                        else this.buttonMessage = "Aguardando Revisão"
                        break;
                    case 'reproved':
                        this.readonlyScreen = true
                        this.disabledButtonNextStep = true
                        this.buttonMessage = `Proposta Reprovada`
                        break;
                    case 'outdated':
                        if (this.isFranchisee) {
                            this.readonlyScreen = true
                            this.disabledButtonNextStep = true
                            this.buttonMessage = `Propostas desatualizadas!`
                        } else {
                            this.readonlyScreen = false
                            this.disabledButtonNextStep = true
                            this.buttonMessage = `Adicionar Proposta`
                        }
                        break;
                    default:
                        if (this.isFranchisee){
                            this.readonlyScreen = true
                            this.disabledButtonNextStep = true
                             this.buttonMessage = "Aguardando Propostas"
                        } else {
                            this.readonlyScreen = false
                            this.disabledButtonNextStep = true
                            this.buttonMessage = "Adicionar Proposta"
                        }
                    break;
                }
            } else {
                if (this.isFranchisee) {
                    this.buttonMessage = `Solicitar Propostas`
                    this.disabledButtonNextStep = false
                    this.readonlyScreen = false
                } else {
                    this.disabledButtonNextStep = true
                    this.readonlyScreen = false
                    this.buttonMessage = "Adicionar Proposta"
                }
            }
        },
        async checkProposalTypeAndGetRequiredFields() {
            const [status, lead] = await LeadsService.getLeadById(this.idLead)
            this.desiredProposal = lead.desiredProposal || []

            const requiredFields = {
                investment: [
                    'checklist',
                ],
                management: [
                    'hydrometer',
                ],
                pre_fixed: [
                    'checklist',
                ],
                model_performance: [
                    'checklist',
                    'historic'
                ],
            }

            this.filterRequiredFields = this.desiredProposal?.reduce((acc, proposal) => {
                const permissions = requiredFields[proposal] || [];
                return [...new Set([...acc, ...permissions])];
            }, []);

        }
    },

    async created() {
        this.is_loading = true;
        if (this.getCurrentUserRank === "Franqueado") this.steps = this.steps.filter(step => step.id !== "proposal");

        await this.getFirestoreDiagnostic()
        await this.checkIndexedDB()

        await this.checkProposalTypeAndGetRequiredFields()

        const [statusProject, project_data] = await ProjectsService.getProjectById(this.idProject)
        this.project_data = project_data;

        this.is_loading = false;
    },
};
